import * as Yup from 'yup';
import { fixGoSlice } from '../helpers/fix-go-types';
import { SalesTotalSchema } from './sales-total';
import { YearSalesSchema } from './year-sales';

const CurrentYearEstimatesSchema = Yup.object().shape({
  totals: SalesTotalSchema.required(),
  monthly: Yup.array().of(SalesTotalSchema).required(),
});

export type CurrentYearEstimates = Yup.InferType<typeof CurrentYearEstimatesSchema>;

// form validation rules
export const StoreSalesStatsSchema = Yup.object().shape({
  // Go serializes a nil `[]YearSalesStats` (no omitempty) as `null`; coerce
  // null → [] so a store with no sales history isn't dropped by validation.
  historical: Yup.array().of(YearSalesSchema).defined().transform(fixGoSlice),
  current_year_estimates: CurrentYearEstimatesSchema.required(),
  last_transaction_date: Yup.date(),
});
